import styled from "styled-components";

export const TableStyle = styled.div`
  table {
    tbody {
        tr {
            :nth-last-child(5) {
                font-weight: bold;
            }
            :nth-last-child(3) {
                font-weight: bold;
            }                          
            :nth-last-child(2) {
                td {
                    border-top: 5px double black;
                    font-weight: bold;
                }                
            }
        }
    }
  }
`;
